// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"0e6bab6f513299cd","931":"b161dcd74afc8b1a"}[chunkId] + ".css";
};